var map = {
	"./css.png": 660,
	"./favicon.png": 6491,
	"./git.png": 1369,
	"./html.png": 5015,
	"./java.png": 711,
	"./js.png": 598,
	"./mongodb.png": 9636,
	"./react.png": 1114,
	"./sql.png": 64,
	"./ss1.png": 6792,
	"./ss2.png": 2675,
	"./ss3.png": 7663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2291;